import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { VehicleIcon } from '@moia-dev/pace-icons'
import { FleetManagementTestingAreaRoutes } from './FleetManagementTestingAreaRoutes'

export const FleetManagementTestingAreaNavigationIcon = VehicleIcon

export const FleetManagementTestingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetManagementTestingAreaRoutes.SimulatorList.route}
      Icon={VehicleIcon}
    />
  )
}
